<section
  data-test="facet-list-panel"
  class="facet-list-panel" [cxFocus]="focusConfig"
  (esc)="onClosePanel('Escape clicked')"
  role="dialog"
  aria-labelledby="dialogTitle"
>
  <div class="facet-list-panel--header h-400" data-test="facet-list-panel--header">
    {{ 'productList.filters.title' | cxTranslate }}
    <button
      class="btn btn-icon" (click)="onClosePanel('Close button clicked')"
      data-test="facet-list-panel--close-btn"
    >
      <mat-icon svgIcon="close" />
    </button>
  </div>
  @if ((facetCategoryList$ | async)?.facetCategories; as facetCategories) {
    <cdk-accordion class="facet-list-panel--body" data-test="facet-list-panel--body">
      @for (facetCategory of facetCategories; track facetCategory.code) {
        <dp-facet-list
          [attr.data-test]="'facet-list-panel--category-' + facetCategory.code"
          [facetCategory]="facetCategory" [selected]="(selectedFacetCategoryCode$ | async) === facetCategory.code"
        />
      }
    </cdk-accordion>
  }
  <div class="facet-list-panel--actions" data-test="facet-list-panel--category-actions">
    <button
      data-test="facet-list-panel--show-all-btn"
      class="btn btn-primary btn-wide" (click)="onClosePanel('Show all filters')"
      [attr.aria-label]="'productList.filters.showResults' | cxTranslate"
    >{{ 'productList.filters.showResults' | cxTranslate }} ({{ totalResults$ | async }})
    </button>
    <button
      class="btn btn-secondary btn-wide" (click)="onClearAllFilters()"
      data-test="facet-list-panel--clear-all-btn"
      [attr.aria-label]="'productList.filters.clearAllFilters' | cxTranslate"
    >{{ 'productList.filters.clearAllFilters' | cxTranslate }}
    </button>
  </div>
</section>
